/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Existing_Subtitle_PrefixInputs */

const en_existing_subtitle_prefix = /** @type {(inputs: Existing_Subtitle_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build documentation from your codebase, then plan the next step here, or start `)
};

const id_existing_subtitle_prefix = /** @type {(inputs: Existing_Subtitle_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buat dokumentasi dari codebase kamu, lalu rencanakan langkah berikutnya di sini, atau mulai `)
};

/**
* | output |
* | --- |
* | "Build documentation from your codebase, then plan the next step here, or start" |
*
* @param {Existing_Subtitle_PrefixInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const existing_subtitle_prefix = /** @type {((inputs?: Existing_Subtitle_PrefixInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Existing_Subtitle_PrefixInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_existing_subtitle_prefix(inputs)
	return en_existing_subtitle_prefix(inputs)
});